import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';

@Injectable()
export class OrderDocumentDeclineService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderDocumentDecline(payload: {
        orderId: string;
        supplementalFileTypeId: string;
        contextMap: string;
        dismissedReason: string;
        firmId?: number;
        fundId?: number;
        holdingOptionId?: number;
    }): Observable<any> {
        return this.http.put<any>(
            `${this.environment.api}orders/${payload.orderId}/supplemental-files/update`,
            {
                supplementalFileTypeId: payload.supplementalFileTypeId,
                contextMap: payload.contextMap,
                dismissedReason: payload.dismissedReason,
                firmId: payload.firmId,
                fundId: payload.fundId,
                holdingOptionId: payload.holdingOptionId
            }
        );
    }
}
